import { ReactComponent as AlertSVG } from './alert.svg';
import IFitButton from '@ifit/react-components/dist/Button';
import './index.scss';

interface IProps {
  buttonText: string;
  errorText: string;
  handleClose: () => void;
}

export default function ErrorScreen({ buttonText, errorText, handleClose }: IProps): JSX.Element {
  return (
    <div className="error-screen">
      <div>
        <AlertSVG className="error-screen-svg" />

        <p className="error-screen-message">{errorText}</p>

        <IFitButton className="error-screen-button" theme="primary" onClick={handleClose}>
          <span>{buttonText}</span>
        </IFitButton>
      </div>
    </div>
  );
}
